// @ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { GeolocationContext } from '@exchange-frontends/components';

import { RequestError } from '../../utils/RequestError';
import searchCcApps from '../actions/search-cc-apps';

/**
 * @param {import('@action-types/ccPublisher').UseCcPublisherInfoOptions} [options]
 * @param {{publisherId: string}} [overrides]
 */
const useCcPublisherInfo = (options, overrides) => {
  const { id } = useParams();
  const { geolocation } = useContext(GeolocationContext);
  const publisherId = overrides?.publisherId || id;
  const isEuUser = geolocation === 'EU';
  const { enabled = true, ...queryOptions } = options ?? {};

  /** @type {import('@action-types/ccApps').CcAppsSearchPayload} */
  const payload = {
    filters: {
      ownerIds: [publisherId],
    },
    pageSize: 1,
  };

  const data = useQuery({
    ...queryOptions,
    queryKey: ['get-publisher-info', publisherId],
    enabled: Boolean(publisherId && enabled),
    queryFn: async ({ signal }) => {
      let response = await searchCcApps({
        signal,
        payload,
      });

      if (response?.jsonResponse?.items?.length === 0 && isEuUser) {
        response = await searchCcApps({
          signal,
          payload,
          viewerCountry: 'IN',
        });
      }

      if (!response?.jsonResponse?.items?.length) {
        throw new RequestError({
          message: 'Publisher not found',
          fetchResponse: {
            ...response?.fetchResponse,
            status: 404,
          },
          jsonResponse: response?.jsonResponse,
          textResponse: response?.textResponse,
        });
      }

      return response?.jsonResponse?.items?.[0]?.owner || null;
    },
  });

  return data;
};

export default useCcPublisherInfo;
